import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const api = buildService(`/nasu-svc/service/v2/custodians`);

export const mockCustodians = [
  {
    csdId: 'a1s2g000000SOmhAAG',
    custodianName: 'Weiss Funds',
    transferTopInstitution: true,
    rolloverTopInstitution: false
  },
  {
    csdId: 'a1s2g000000SOmmAAG',
    custodianName: 'New York Life Annuity Service Center',
    transferTopInstitution: true,
    rolloverTopInstitution: true
  },
  {
    csdId: 'a1s2g000000SOmyAAG',
    custodianName: 'TD Bank',
    transferTopInstitution: true,
    rolloverTopInstitution: true
  },
  {
    csdId: 'a1s2g000000SOhLAAW',
    custodianName: 'Credit Suisse',
    transferTopInstitution: true,
    rolloverTopInstitution: true
  },
  {
    csdId: 'a1s2g000000SOhKAAW',
    custodianName: 'Vanguard',
    transferTopInstitution: true,
    rolloverTopInstitution: true
  }
];

export const getCustodiansService = async (): Promise<any> => {
  if (settings['mockedMode']) return mockCustodians;
  return api.index();
};

export default api;
